import { useCallback } from 'react';

import * as evmChains from 'viem/chains';

import { Currency, CAIP_122_IDS } from '@/constants';

const CHAIN_ID_TO_COLOR: Record<string, string> = {
  // EVM
  [evmChains.mainnet.id]: 'hsl(var(--chain-1))',
  [evmChains.bsc.id]: 'hsl(var(--chain-56))',
  [evmChains.polygon.id]: 'hsl(var(--chain-137))',
  [evmChains.tron.id]: 'hsl(var(--chain-728126428))',

  // Bitcoin-like
  [BigInt('0x' + CAIP_122_IDS[Currency.BTC].split(':')[1]).toString()]: 'hsl(var(--chain-31235661622419893084429971))',
  [BigInt('0x' + CAIP_122_IDS[Currency.DOGE].split(':')[1]).toString()]:
    'hsl(var(--chain-35317432377435084521929519164642950786))',
  [BigInt('0x' + CAIP_122_IDS[Currency.LTC].split(':')[1]).toString()]:
    'hsl(var(--chain-24795284017566858906454004088655802008))',
  litecoin: 'hsl(var(--chain-24795284017566858906454004088655802008))',
};

type ChainIdLike = string | number | bigint;

export const useChainIdToColor = () => {
  return useCallback((chainId: ChainIdLike): string => {
    const chainIdStr = String(chainId);
    return CHAIN_ID_TO_COLOR[chainIdStr] || 'hsl(var(--chart-5))';
  }, []);
};
